import { forwardRef, createElement } from 'react';
import cn from 'classnames';

const Extra = /*#__PURE__*/forwardRef(function DialogExtra(props, ref) {
  const className = cn('bg-grey-light yt-shadow-inset absolute top-full left-0 -mt-px w-full rounded-t-none rounded-b p-6 text-left', props.className);
  return createElement("div", Object.assign({}, props, {
    className: className,
    "data-taco": "dialog-extra",
    ref: ref
  }));
});
Extra.displayName = 'DialogExtra';

export { Extra };
//# sourceMappingURL=Extra.js.map
